module.exports = __webpack_public_path__ + "static/media/12_a_background.264aadc3.png";